import { TableRow as MUITableRow, TableRowProps } from '@mui/material';

export { type TableRowProps } from '@mui/material';

export function TableRow(props: TableRowProps) {
  return <MUITableRow {...props} />;
}
